<script lang="ts" setup>
import './_index.scss'

import { computed, inject } from 'vue'
import IconHouseFavorite from '@lahaus-roomie/roomie/src/assets/icons/house-favorite.svg'
import IconCheckSm from '@lahaus-roomie/roomie/src/assets/icons/check-sm.svg'

import type { InvestmentProject } from '@/server/api/buyer-front/types'
import { investmentProjectKey } from '@/symbols/listing'

const { t } = useI18n()

const listing = inject(investmentProjectKey) as InvestmentProject

const reasons = computed(() => {
  if (!listing.investments_config) return []

  const perks = listing.investments_config[0]?.attributes?.perks?.replace(/-/g, '').split('\n') ?? []

  return perks.filter(reason => !reason.includes('<ul>') && !reason.includes('</ul>') && reason.trim() !== '')
})

const showPerks = () => {
  const { length } = reasons.value

  if (length === 1) {
    return reasons.value[0].length > 10
  } else if (length > 1) {
    return true
  }
  return false
}

</script>

<script lang="ts">
export default {
  name: 'PdReasonProject'
}
</script>

<template>
  <section
    v-if="showPerks()"
    class="reason-project py-32 px-24">
    <div class="reason-project__title-container">
      <h3>
        {{ t('reasonProject.title.why') }}
        <span>
          {{ t('reasonProject.title.like') }}
        </span>
        {{ t('reasonProject.title.project') }}
      </h3>

      <span class="reason-project__title-icon">
        <IconHouseFavorite class="fill-white" />
      </span>
    </div>

    <ul class="reason-project__cards-container">
      <li
        v-for="(reason, index) in reasons"
        :key="index">
        <span class="reason-project__card-icon">
          <IconCheckSm class="fill-white" />
        </span>

        <p v-sanitize="reason" />
      </li>
    </ul>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
